module.exports = __webpack_public_path__ + "img/help-icon.fded9a51.svg";